// extracted by mini-css-extract-plugin
export default {"wrapper":"styles__wrapper___w5v0W","innerWrapper":"styles__innerWrapper___OruP0","fullWidth":"styles__fullWidth___kWoih"};